
export default {
  data: () => ({
    errors: []
  }),
  methods: {
    storeError (err) {
      console.error(err)
      this.errors.push(err.message || err)
    },
    clearErrors () {
      this.errors = []
    }

  }
}
